<div class="text-[16px] w-[100vh]">
  <ul class="">
    <li class="mb-2">
      <!-- toggle new alert contact -->
      <button (click)="toogleNewEmailInput=!toogleNewEmailInput" class="px-5 py-1 ml-3 rounded-lg bg-cliking_blue text-white mt-1">
        <svg xmlns="http://www.w3.org/2000/svg" width="22"  viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-badge-plus-icon lucide-badge-plus"><path d="M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"/><line x1="12" x2="12" y1="8" y2="16"/><line x1="8" x2="16" y1="12" y2="12"/></svg>
      </button> 

      <span *ngIf="toogleNewEmailInput">
        <input class="border border-gray-500 rounded-lg  ml-5 p-1 w-96" type="email" [(ngModel)]="tmpContact">
        <button (click)="add(tmpContact)" class="px-5 py-2 ml-3 rounded-lg bg-cliking_green text-white" >
          <svg xmlns="http://www.w3.org/2000/svg" width="24"  viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-save-icon lucide-save"><path d="M15.2 3a2 2 0 0 1 1.4.6l3.8 3.8a2 2 0 0 1 .6 1.4V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z"/><path d="M17 21v-7a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v7"/><path d="M7 3v4a1 1 0 0 0 1 1h7"/></svg>
        </button>
      </span>
    </li>
    <li *ngFor="let item of contacts" class="">
      <span class="join gap-2 my-2">

        <!-- rendering item -->
        <span class="text-black">
          <p *ngIf="!iseditModOn  ">{{item.email}}</p>
          <input class="border border-gray-500 rounded-lg  ml-5 p-1 w-72" *ngIf="iseditModOn && currentItem.id===item.id" [type]="inputType" [(ngModel)]="tmpUpdate">
        </span>
        
        <!--  edit -->
        <span *ngIf="!iseditModOn" class="text-cliking_blue rounded-full cursor-pointer p-0.5" (click)="edit(item)">
          <svg xmlns="http://www.w3.org/2000/svg" width="20"  viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" ><path d="M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z"/><path d="m15 5 4 4"/></svg>
        </span>
      <!-- confirm -->
      <span *ngIf="iseditModOn && currentItem.id===item.id" class="text-cliking_green rounded-full cursor-pointer p-0.5" (click)="update(item)" >
        <svg xmlns="http://www.w3.org/2000/svg" width="22"  viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" ><path d="M20 6 9 17l-5-5"/></svg>
      </span>
      <!-- remove -->
      <span *ngIf="!iseditModOn" class="text-cliking_red rounded-full cursor-pointer p-0.5" (click)="remove(item)">
        <svg xmlns="http://www.w3.org/2000/svg rounded-full" width="22"  viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" ><circle cx="12" cy="12" r="10"/><path d="m15 9-6 6"/><path d="m9 9 6 6"/></svg>
      </span>
      
    </span>
    </li>
  </ul>
</div>
